import React, { useContext, useMemo, useState } from 'react';
import "./writeup.css";
import Page from '../../Utilities/Page';
import Card from '../../Utilities/Card';
import FilterBar from '../../Utilities/FilterBar';
import DataContext from '../../../DataContext';

const RESULTS = ["Podium", "Ranked", "Unplaced"];

const resultOf = (placement) => {
  if (!placement) return "Unplaced";
  if (/1st|2nd|3rd|champion/i.test(placement)) return "Podium";

  return "Ranked";
}

const Writeup = () => {
  const { writeups } = useContext(DataContext);
  const [search, setSearch] = useState("");
  const [type, setType] = useState("");
  const [result, setResult] = useState("");

  const types = useMemo(() => {
    const found = (writeups || []).map(writeup => writeup.data && writeup.data.type).filter(Boolean);

    return [...new Set(found)].sort((a, b) => a.localeCompare(b));
  }, [writeups])

  const shown = useMemo(() => {
    const term = search.trim().toLowerCase();

    return (writeups || []).filter(writeup => {
      const record = writeup.data || {};
      const title = record.title || "";

      if (term !== "" && !title.toLowerCase().includes(term)) return false;
      if (type !== "" && record.type !== type) return false;
      if (result !== "" && resultOf(record.placement) !== result) return false;

      return true;
    })
  }, [writeups, search, type, result])

  /* the shell stays mounted while the records load, so the navigation bar
     and the footer never disappear between routes */
  const loading = !writeups || writeups.length === 0;

  return (
    <Page cls='writeup fcs' title='Write Ups | Chai Cheng Xun'>
      <div className="page-wrap">
        <div className="cmd"><span className="prompt">$</span> ls ~/writeups</div>
        <div className="d-title">CTF Write Ups</div>
        <div className="d-text intro">
          Solutions I wrote up after playing capture the flag competitions, challenge by challenge.
        </div>
        {loading ? (
          <div className="d-text loading">Loading...</div>
        ) : (
        <>
        <FilterBar
          placeholder='Search write ups...'
          search={search}
          setSearch={setSearch}
          filters={[
            { label: "All Types", options: types, value: type, onChange: setType },
            { label: "All Results", options: RESULTS, value: result, onChange: setResult }
          ]}
          shown={shown.length}
          total={(writeups || []).length}
        />
        <div className="card-list">
          {
            shown.map(writeup => {
              const record = writeup.data || {};

              return (
                <Card
                  key={writeup.id}
                  to={record.link || ""}
                  title={record.title}
                  meta={record.type}
                  badges={record.placement ? <span className="badge gold">{record.placement}</span> : null}
                />
              )
            })
          }
          {shown.length === 0 && <div className="d-text empty">Nothing matches those filters.</div>}
        </div>
        </>
        )}
      </div>
    </Page>
  )
}

export default Writeup
